import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { EmailVerifyBanner } from './EmailVerifyBanner';

// Standard site chrome (navbar + footer) wrapping page content.
export default function MainLayout() {
  const { pathname } = useLocation();
  const isMap = pathname === '/map';

  useEffect(() => {
    if (isMap) {
      const originalBodyOverflow = document.body.style.overflow;
      const originalHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalBodyOverflow;
        document.documentElement.style.overflow = originalHtmlOverflow;
      };
    }
  }, [isMap]);

  return (
    <div className={isMap ? 'h-screen overflow-hidden flex flex-col bg-background' : 'min-h-screen flex flex-col bg-background'}>
      <Navbar />
      <EmailVerifyBanner />
      <main className={isMap ? 'flex-1 min-h-0 overflow-hidden' : 'flex-1'}>
        <Outlet />
      </main>
      {!isMap && <Footer />}
    </div>
  );
}
